// extracted by mini-css-extract-plugin
export default {"stage":"styles_stage__S9USZ","rotate":"styles_rotate__KHGkg","ring":"styles_ring__YQ-Jp","poster":"styles_poster__KjEOU"};